import React from 'react';
import Estimate from '../../pages/ServiceOrderPage/Estimate';
import { Box } from '@mui/material';

export default function EstimateTab({ order, stockNumber, setOrder }) {
  return (
    <Box>
      <Estimate order={order} />
    </Box>
  );
}

